import { webtoons } from "@/mocks/webtoons";

export default function Ranking() {
  const ranked = [...webtoons].sort((a, b) => b.score - a.score).slice(0, 8);

  return (
    <section
      id="ranking"
      className="scroll-mt-20 bg-background-100 py-14 md:py-20"
    >
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="flex flex-col gap-2">
          <span className="inline-flex items-center gap-2 text-sm font-medium text-accent-600">
            <i className="ri-trophy-fill"></i>
            高分榜单
          </span>
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
            豆瓣高分 · 口碑韩漫 Top 榜
          </h2>
          <p className="text-sm text-foreground-600 md:text-base">
            综合豆瓣评分与站内试读口碑，更新至本周的受欢迎榜单。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 lg:grid-cols-2">
          {ranked.map((w, idx) => (
            <article
              key={w.id}
              className="group flex items-center gap-4 rounded-lg bg-background-50 p-3 transition-colors hover:bg-background-50/80 md:gap-5 md:p-4"
            >
              <span
                className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-md font-heading text-lg font-bold ${
                  idx < 3
                    ? "bg-accent-500 text-background-50"
                    : "bg-background-200 text-foreground-700"
                }`}
              >
                {idx + 1}
              </span>
              <div className="h-20 w-14 shrink-0 overflow-hidden rounded-md">
                <img
                  src={w.cover}
                  alt={`${w.title}高分韩漫封面`}
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <div className="min-w-0 flex-1">
                <div className="flex items-center justify-between gap-2">
                  <h3 className="truncate font-heading text-base font-bold text-foreground-950">
                    {w.title}
                  </h3>
                  <span className="shrink-0 font-heading text-base font-bold text-primary-600">
                    {w.score.toFixed(1)}
                  </span>
                </div>
                <p className="mt-0.5 truncate text-xs text-foreground-500">
                  {w.genreLabel} · {w.status} · {w.episode}话
                </p>
                <div className="mt-1.5 flex flex-wrap gap-1.5">
                  {w.tags.slice(0, 2).map((t) => (
                    <span
                      key={t}
                      className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900"
                    >
                      {t}
                    </span>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}